import React, { useState, useEffect, useRef } from "react";
import logo from "../../../Assets/Images/logo.svg";
import clinicLogo from "../../../Assets/Images/clinic.svg";
import utils from "../../../Utils";
import Select, { components } from "react-select";
import "./Header.css";
import authService from "../../../Services/authService";
import { useNavigate } from "react-router-dom";
import strings from "../../../Utils/strings";
import languageImg from "../../Assets/Images/language.svg";
import UseClickOutside from "./UseClickOutside";
import utilFunctions from "../../../Utils/utilFunctions";
import { useTranslation } from "react-i18next";
import clinicService from "../../../Services/clinicService";
import { getToken } from "firebase/messaging";
import { messaging } from "../../../Firebase/config";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

function Header() {
  const nav = useNavigate();
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [clinicResponse, setClinicResponse] = useState({});
  const [docRes, setDocREs] = useState({});
  const [hospitalName, setHospitalName] = useState("");
  const [hospitalAddress, setHospitalAddress] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let isDoctor = authService.getIsDoctorLogin();
    setIsDoctorLogin(isDoctor);
    getClinicProfile();
    if (authService.getIsDoctorLogin() === "true") {
      getDoctorDetials();
    }
  }, []);

  useEffect(() => {
    setHospitalName(authService.getHospitalName() || clinicResponse?.hospital?.name);
    console.log(clinicResponse);
    if (language === "vietnam") {
      setHospitalAddress(clinicResponse?.hospital?.address?.vi || authService.getHospitalAddress());
    } else {
      setHospitalAddress(clinicResponse?.hospital?.address?.en || authService.getHospitalAddress());
    }
  }, [clinicResponse]);

  useEffect(() => {
    if (language === "vietnam") {
      setDoctorName(authService.getDoctorNameVi() || docRes.name?.vi);
    } else {
      setDoctorName(authService.getDoctorNameEn() || docRes.name?.en);
    }
    console.log(authService.getDoctorName());
  }, [docRes]);

  const postFcmToken = async (fcmToken) => {
    function generateUniqueId() {
      return `${Date.now()}-${Math.floor(Math.random() * 100000000000)}`;
    }
    const uniqueId = generateUniqueId();
    const LocalFcmId = localStorage.getItem(strings.localStorage.deviceId);

    const body = {
      type: "WEB",
      name: LocalFcmId || uniqueId,
      id: LocalFcmId || uniqueId,
      token: fcmToken,
    };

    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.doctorFcmToken(body);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalFcmToken(body);
      }
      if (response.status === "success") {
        localStorage.setItem(strings.localStorage.fcmToken, response.data.token.device.token);
        localStorage.setItem(strings.localStorage.deviceId, response.data.token.device.id);
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const currentLanguage = i18n.language;
    const initialLanguage = utils.constants.languageOptions.find((option) => option.value === currentLanguage);
    setSelectedLanguage(initialLanguage);
  }, [i18n.language]);

  useEffect(() => {
    const requestNotificationPermission = async () => {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        try {
          const fcmToken = await getToken(messaging, {
            vapidKey: "BOhzQmz2wSvJTWYQ1BW8lWGB68bTYKnP0nFTkLZVjETbw3vf-oMbG9yVuazd9rfhzKUrkn2iKFvNM-sjZxM1Vps",
          });

          if (fcmToken) {
            const localFcmToken = localStorage.getItem(strings.localStorage.fcmToken);
            if (fcmToken && fcmToken !== localFcmToken) {
              postFcmToken(fcmToken);
            }
          }
        } catch (error) {
          console.error("Error getting FCM token:", error);
        }
      } else {
        console.error("Permission not granted for notifications.");
      }
    };

    requestNotificationPermission();

    setInterval(() => {
      requestNotificationPermission();
    }, 5 * 60 * 1000);
  }, []);

  const handleMenuOpen = () => {
    setIsOpen(true);
  };

  const handleMenuClose = () => {
    setIsOpen(false);
  };

  const divRef = useRef(null);
  UseClickOutside(divRef, handleMenuClose);

  const handleViewProfile = () => {
    if (isDoctorLogin === "false") {
      nav(strings.navigation.viewClinicProfile);
    } else {
      nav(strings.navigation.doctorProfileView);
    }
  };

  const changeLanguage = (lng) => {
    console.log("err", lng);

    utilFunctions.changeLanguage(i18n, lng);

    setSelectedLanguage(utils.constants.languageOptions.find((option) => option.value === lng));
  };

  const getClinicProfile = async () => {
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetClinicProfile();
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalProfile();
      }
      if (response.status === "success") {
        setClinicResponse(response.data);
        authService.setClinicName(response.data.hospital.name);
        if (language === "vietnam") {
          authService.setHospitalAddress(response.data.hospital.address?.vi);
        } else {
          authService.setHospitalAddress(response.data.hospital.address?.en);
        }

        authService.setClinicId(response.data.hospital._id);
        authService.setPhoneNumber(response.data.hospital.phoneNumber);
        authService.setCountryCode(response.data.hospital.countryCode);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLanguageChange = (option) => {
    setSelectedLanguage(option);
    i18n.changeLanguage(option.value);
    window.location.reload();
  };

  const getDoctorDetials = async () => {
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.getDoctorDetials();
        console.log("getting header doc profile", response);
      }
      if (response.status === "success") {
        setDocREs(response.data.doctor);
        authService.setDoctorName(response.data.doctor.name.en);
        authService.setDoctorNameEn(response.data.doctor.name.en);
        authService.setDoctorNameVi(response.data.doctor.name.vi);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <div>{props.children}</div>
      </components.SingleValue>
    );
  };

  return (
    <>
      <header
        className="absolute w-[100%] h-[65px] z-20"
        style={{ background: "white" }}
        onClick={() => {
          console.log("clicked");
        }}
      >
        <div className="absolute w-[20%] left-[6rem] mt-6 md:left-22 md:mt-3">
          <img src={logo} alt="logo_img" className="h-[30px] max-w-[125px] md:max-w-none" />
        </div>
        <div className="absolute right-10 mt-[10px] md:mt-0 width: auto; language-hospital-resp">
          <div className="flex items-center header-icon-resp">
            <img src={clinicLogo} alt="clinicLogo" className="h-[2rem] mr-2 clinic-logo-resp" />
            {isDesktop && (
              <div className="mt-2">
                <div className="text-l mt-2 profile-clinic-name" onClick={handleViewProfile}>
                  {isDoctorLogin === "false" ? hospitalName : doctorName}
                </div>
                <p className="text-gray-500 text-sm">
                  {isDoctorLogin === "false" ? (hospitalAddress?.length > 20 ? `${hospitalAddress.slice(0, 20)}...` : hospitalAddress) : hospitalName}
                </p>
              </div>
            )}

            <div className="d-flex">
              <img src={languageImg} className="language-img" alt="Language" />
              <div ref={divRef}>
                {/* <Select
                  className="select-language"
                  isSearchable={false}
                  options={utils.constants.languageOptions}
                  styles={utils.appStyles.languageDropDown}
                  // onChange={(option) => changeLanguage(option.value)}
                  onChange={(option) => {
                    changeLanguage(option.value);
                    window.location.reload();
                  }}
                  value={selectedLanguage}
                  getOptionLabel={(option) => (
                    <div>
                      <div>{option.label}</div>
                      <div>{option.subTitle}</div>
                    </div>
                  )}
                  components={{ SingleValue }}
                  menuPortalTarget={document.body}
                  menuIsOpen={isOpen}
                  onMenuOpen={handleMenuOpen}
                  onMenuClose={handleMenuClose}
                /> */}
                {/* <div>{utils.constants.languageOptions.map(item=>{
                  return <span>{item.label}</span>
                }

                )}</div> */}
                <Select
                  className="select-language"
                  isSearchable={false}
                  options={utils.constants.languageOptions}
                  styles={utils.appStyles.languageDropDown}
                  // onChange={(option) => changeLanguage(option.value)}
                  onChange={handleLanguageChange}
                  value={selectedLanguage}
                  getOptionLabel={(option) => (
                    <div>
                      <div>{option.label}</div>
                      <div>{option.subTitle}</div>
                    </div>
                  )}
                  components={{ SingleValue }}
                  menuPortalTarget={document.body}
                  menuIsOpen={isOpen}
                  onMenuOpen={handleMenuOpen}
                  onMenuClose={handleMenuClose}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
